import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import XeroTimesheetExport from './TimesheetExport';
import XeroEmployeeImport from './XeroEmployeeImport';


function XeroDashboard() {
  return (
   <div>
      <h2>Welcome</h2>
      <ul>
        <li><Link to="/xerotimesheetexport">Export Timesheet</Link></li>
        <li><Link to="/xeroemployeeimport">Import Employees</Link></li>
      </ul>
    </div>
  );
}

export default XeroDashboard;
